import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Person } from 'app/shared/models/person.model';

@Component({
    selector: 'app-identity-match-dialog',
    templateUrl: './identity-match-dialog.component.html',
    styleUrls: ['./identity-match-dialog.component.scss'],
    standalone: false
})
export class IdentityMatchDialogComponent implements OnInit {
  matches: Person[];
  selectedMatch: Person;
  noMatch: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<IdentityMatchDialogComponent>) { 
    this.matches = this.data.matches;
  }

  ngOnInit() {
    if (this.matches.length > 0) {
      this.noMatch = true;
    }
  }

  selectMatch(match: Person) {
    this.selectedMatch = match;
  }

  createNewIdentity() {
    this.dialogRef.close({
      action: "new"
    })
  }

  selectExistingIdentity() {
    this.dialogRef.close({
      action: "match",
      person: this.selectedMatch
    })
  }
}
